import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/SignUp/desktop';
import Mobile from 'pages/SignUp/mobile';
import Tablet from 'pages/SignUp/tablet';

const PageLayout = () => {
    const { device } = useViewport();

    const props = {};

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return renderResponsiveLayout(device);
};

export default PageLayout;
